import { apiDate, optional, optionalString, string, uuid, zenum, zodLess, ZodLessInfer } from '@kaiizen/zod-less';

export const ContractorSuggestionStatusSchema = zenum('pending', 'approved', 'rejected');

export const ApiContractorSuggestionSchema = zodLess({
  id: uuid,
  name: string,
  trade: string,
  orgMarketId: uuid,
  status: ContractorSuggestionStatusSchema,
  suggestedByUserId: uuid,
  suggestedAt: apiDate,
  approvedAt: optional(apiDate),
  approvedByUserId: optionalString,
  orgContractorId: optionalString,
});

export type ApiContractorSuggestion = ZodLessInfer<typeof ApiContractorSuggestionSchema>;
